/* AnimeWear upsell + discount codes kept on the cart.
   Markup for the offer comes from sections/aw-upsell.liquid.

   Codes are written to the cart itself (cart/update.js `discount`), so they show in the cart drawer,
   in the Dostavi BG checkout step and in Shopify checkout alike. enforce() runs on load and after every
   cart update and keeps the managed codes in sync, leaving any other code (e.g. ALEXFRANX10) untouched:
   - the upsell code (EXTRA20) only while the product added FROM the upsell is still in the cart
     (its variant is stored in the hidden cart attribute `_aw_upsell`);
   - the customer's lucky-wheel prize code (window.awMemberCode, set by sections/aw-lucky-wheel.liquid) while a
     customer without orders is logged in; if window.awMemberCodeProduct is set (cap prize), only while that
     product is in the cart;
   - any other lucky-wheel code (KOLELO*) is removed: after the first order, after logging out, or one that
     Shopify carried over from an earlier cart via the discount_code cookie;
   - retired codes (PROFIL5 members' 5%) are removed. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PAGE = ROOT + 'pages/upsell';
  var SEEN_KEY = 'aw-upsell-seen';
  var ATTR = '_aw_upsell';
  var DEFAULT_CODE = 'EXTRA20';
  var RETIRED = ['PROFIL5'];
  var WHEEL = /^KOLELO/;
  var onUpsellPage = location.pathname.replace(/\/$/, '') === PAGE.replace(/\/$/, '');

  function upsellCode() {
    var box = document.querySelector('.aw-upsell[data-code]');
    return ((box && box.dataset.code) || DEFAULT_CODE).toUpperCase();
  }

  function memberCode() {
    return String(window.awMemberCode || '').toUpperCase();
  }

  // Codes this script owns: they are only ever on the cart because enforce() put them there.
  function managed(code, upsell) {
    return code === upsell || RETIRED.indexOf(code) !== -1 || WHEEL.test(code);
  }

  function markSeen() {
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
  }

  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* ---------- Guard: keep the managed codes in sync with the cart ---------- */

  function codesInCart(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function (d) { if (d && d.code) codes.push(String(d.code).toUpperCase()); });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a && a.type === 'discount_code' && a.title) codes.push(String(a.title).toUpperCase());
    });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (al) {
        var a = al.discount_application;
        if (a && a.type === 'discount_code' && a.title) codes.push(String(a.title).toUpperCase());
      });
    });
    return codes.filter(function (c, i) { return codes.indexOf(c) === i; });
  }

  function sameCodes(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (c) { return b.indexOf(c) !== -1; });
  }

  // Shopify can keep a code in the discount_code cookie and put it on the next cart; the cart is the single
  // source here, so drop the cookie whenever it holds a managed code.
  function clearCodeCookie(member, upsell) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    var val = decodeURIComponent(m[1]).toUpperCase().split(',').map(function (s) { return s.trim(); });
    var hit = val.some(function (c) { return c === member || managed(c, upsell); });
    if (hit) document.cookie = 'discount_code=; Max-Age=0; path=/';
    return hit;
  }

  var enforcing = null;
  function enforce() {
    if (enforcing) return enforcing;
    var code = upsellCode();
    var member = memberCode();
    var needProduct = String(window.awMemberCodeProduct || '');
    enforcing = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var attrs = cart.attributes || {};
        var upsellId = String(attrs[ATTR] || '');
        var line = upsellId && items.some(function (i) { return String(i.variant_id) === upsellId; });
        var upsellValid = line && cart.item_count >= 2;
        var memberOk = member && (!needProduct || items.some(function (i) {
          return String(i.product_id) === needProduct;
        }));

        var codes = codesInCart(cart);
        var wanted = codes.filter(function (c) { return c !== member && !managed(c, code); });
        if (upsellValid) wanted.push(code);
        if (memberOk) wanted.push(member);

        var cookieHad = clearCodeCookie(member, code);
        var body = {};
        if (!sameCodes(wanted, codes)) body.discount = wanted.join(',');
        if (upsellId && !upsellValid) { body.attributes = {}; body.attributes[ATTR] = ''; }
        if (!('discount' in body) && !body.attributes) return cookieHad;

        return postJSON('cart/update.js', body).then(function () { return true; });
      })
      .catch(function () { return false; })
      .finally(function () { enforcing = null; });
    return enforcing;
  }

  function enforceAndRefresh() {
    return enforce().then(function (changed) {
      if (!changed) return;
      if (location.pathname.replace(/\/$/, '') === (ROOT + 'cart').replace(/\/$/, '')) {
        location.reload();
      } else {
        return refreshDrawer(false);
      }
    });
  }

  /* ---------- 1. Checkout clicks ---------- */
  // No interstitial page: the offer is already shown in the cart drawer.
  // Checkout clicks pass through untouched so the delivery app (Dostavi BG) opens as usual.
  // The codes are kept in sync by enforceAndRefresh() on every cart update.

  // Continue / skip on the upsell page: clean up the code first.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.aw-upsell__continue, .aw-upsell__skip');
    if (!link) return;
    e.preventDefault();
    enforce().then(function () { location.href = link.getAttribute('href'); });
  });

  /* ---------- 2. Cart drawer offer ---------- */

  var rendering = false;
  function renderDrawerUpsell() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || rendering) return;
    var inner = drawer.querySelector('.drawer__inner');
    var footer = drawer.querySelector('.drawer__footer');
    if (!inner || !footer || inner.classList.contains('is-empty')) return;
    rendering = true;
    fetch(ROOT + '?section_id=aw-upsell')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var box = tmp.querySelector('.aw-upsell');
        drawer.querySelectorAll('.aw-upsell').forEach(function (n) { n.remove(); });
        var f = drawer.querySelector('.drawer__footer');
        if (box && box.dataset.mode !== 'none' && box.querySelector('.aw-upsell__item') && f) {
          box.classList.add('aw-upsell--drawer');
          f.parentNode.insertBefore(box, f);
        }
      })
      .catch(function () {})
      .finally(function () { rendering = false; });
  }

  function refreshDrawer(open) {
    var drawer = document.querySelector('cart-drawer');
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!drawer || typeof drawer.renderContents !== 'function') {
          if (open !== false) location.reload();
          return;
        }
        var wasOpen = drawer.classList.contains('active');
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections });
        if (open === false && !wasOpen && typeof drawer.close === 'function') {
          setTimeout(function () { drawer.close(); }, 0);
        }
      });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        return !(m.target.closest && m.target.closest('.aw-upsell'));
      });
      if (!relevant) return;
      clearTimeout(t);
      t = setTimeout(function () {
        if (!drawer.querySelector('.aw-upsell')) renderDrawerUpsell();
      }, 250);
    }).observe(drawer, { childList: true, subtree: true });
    renderDrawerUpsell();
  }

  /* ---------- 3. Add an offered product ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aw-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.aw-upsell');
    var card = btn.closest('.aw-upsell__item');
    var select = card && card.querySelector('.aw-upsell__select');
    var id = Number(select ? select.value : btn.dataset.variantId);
    var mode = box ? box.dataset.mode : 'extra';
    btn.disabled = true;
    btn.classList.add('loading');

    postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); })
      .then(function () {
        if (mode !== 'extra') return;
        // Mark the upsell line; enforce() then adds the upsell code next to any code already in the cart.
        var body = { attributes: {} };
        body.attributes[ATTR] = String(id);
        return postJSON('cart/update.js', body).then(function () { return enforce(); });
      })
      .then(function () {
        if (onUpsellPage) {
          location.href = ROOT + 'checkout';
          return;
        }
        markSeen(); // offer taken: next checkout click goes straight to checkout
        return refreshDrawer(true);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
  });

  /* ---------- Init ---------- */

  function init() {
    watchDrawer();
    enforceAndRefresh();
    // Dawn's pubsub.js / constants.js declare these as top-level globals (not window props).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { enforceAndRefresh(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
